// DstackQueryEditor.tsx
import React, { useState } from 'react';
import './Dstack2.css';
// Import icons from react-icons (using Font Awesome icons as an example)
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';


export interface DstackQueryEditorProps {
  onRunQuery: (queryText: string, codeSnippet?: string) => void;
  // It's highly recommended to pass isLoading from the parent
  isLoading: boolean;
};

// Removed DStackShowCodeSnippet component as its logic is now inline

const DstackQueryEditor = ({ onRunQuery, isLoading }: DstackQueryEditorProps) => {
  const [queryText, setQueryText] = useState<string>('');
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [codeSnippet, setCodeSnippet] = useState('');

  const handleRun = () => {
    // Pass both callStack and codeSnippet to the handler
    onRunQuery(queryText, codeSnippet);
  };

  // Function to handle closing the code snippet input
  const handleHideCodeInput = () => {
    setShowCodeInput(false);
    setCodeSnippet(''); // Optionally clear the snippet when hiding
  };

  return (
    <div className="input-section">
      <textarea
        id="callStack"
        value={queryText}
        onChange={(e) => setQueryText(e.target.value)}
        placeholder="Paste your call stack here... please do not add characters that violate HTML safety"
        className="dstack-textarea"
      />

      {/* Code Snippet Input Area (Conditional) */}
      {showCodeInput && (
        <div className="mt-4"> {/* Added margin-top */}
          <div className="flex justify-between items-center mt-2">
            <label htmlFor="codeSnippet" className="block font-semibold">Code Snippet (Optional):</label>
            <button
              onClick={handleHideCodeInput} // Use the handler
              className="text-gray-500 hover:text-red-600 font-bold px-2 py-1 mr-4 bg-slate-300 text-xl" // Adjusted styling
              title="Hide Code Snippet Input"
            >
              &times; {/* Use HTML entity for 'X' */}
            </button>
          </div>

          <textarea
            id="codeSnippet"
            value={codeSnippet}
            onChange={(e) => setCodeSnippet(e.target.value)}
            placeholder="Paste relevant code snippet here..."
            rows={20}
            className="dstack-textarea"
          />
        </div>
      )}      

      {/* Buttons Row */}
      <div className="flex items-center mb-2 mt-4 ml-2 mr-4">
        {/* Conditionally render the "Add Code Snippet" button */}
        {!showCodeInput && (
          <button
            onClick={() => setShowCodeInput(true)}
            // Added flex, items-center, space-x-2 for icon layout
            className="deriq-action-button flex items-center space-x-2"
          >
            <FontAwesomeIcon icon={faCode} />
            <span className="text-gray-200">Add Code Snippet (optional)</span> {/* Removed (Optional) for brevity */}
          </button>
        )}

        {/* "Get Dstack" button - ml-auto pushes it to the far right */}
        <button
          onClick={handleRun}
          disabled={!queryText || isLoading}
          // Added flex, items-center, space-x-2 for icon layout
          className="deriq-action-button disabled:opacity-50 max-w-[200px] w-full ml-auto flex items-center justify-center space-x-2" // Added justify-center
        >
          <FontAwesomeIcon icon={faLayerGroup} />
          <span>{isLoading ? 'Getting...' : 'Get Dstack'}</span> 
        </button>
      </div>

    </div>
  );
};

export default DstackQueryEditor;
